// import React from "react";
// import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";

// const Disclaimer = () => {
//   const docs = [
//     {
//       uri:require("./Disclaimer.pdf"),
//     },

//   ];
//   return (
//     <div>
//       <DocViewer
//         documents={docs}
//         pluginRenderers={DocViewerRenderers}
//         style={{ height: 600, overflow: "auto" }}
//         config={{
//           header: { disableHeader: true },
//           pdfZoom: {
//             defaultZoom: 1.1, // 1 as default,
//             zoomJump: 0.2, // 0.1 as default,
//           },
//           pdfVerticalScrollByDefault: true, // false as default
//         }}
//       />
//     </div>
//   );
// };

// export default Disclaimer;

const Disclaimer = () => (
  <div className="mx-auto max-w-3xl px-6 py-16 text-center">
    <h1 className="text-3xl font-semibold text-gray-900">Disclaimer</h1>
    <p className="mt-4 text-gray-600">
      Disclaimer details are currently unavailable. Please contact support for the latest information.
    </p>
  </div>
);

export default Disclaimer;
